import { WorkflowActionBlock } from '../../workflows/views/createWorkflows/types'

export const mergeWorkflowActionOverrides = (
  workflowActions: WorkflowActionBlock[] = [],
  policyActions: WorkflowActionBlock[] = []
): WorkflowActionBlock[] => {
  const policyActionsByType = new Map(
    policyActions.map((action) => [action.actionType, action] as const)
  )

  return workflowActions.map((workflowAction) => {
    const policyAction = policyActionsByType.get(workflowAction.actionType)

    if (!policyAction) {
      return workflowAction
    }

    return {
      ...workflowAction,
      id: policyAction.id || workflowAction.id,
      notificationRecipientGroups:
        policyAction.notificationRecipientGroups || workflowAction.notificationRecipientGroups,
      additionalNotificationRecipients:
        policyAction.additionalNotificationRecipients ||
        workflowAction.additionalNotificationRecipients,
      approverGroups: policyAction.approverGroups || workflowAction.approverGroups,
      additionalApproverRecipients:
        policyAction.additionalApproverRecipients || workflowAction.additionalApproverRecipients
    }
  })
}
